export default {"src":"/_next/static/media/ElevateLogoAndWords.d23043b6.svg","height":43,"width":208};